import aboutContent from './content/about.json';

const aboutMock = {
    layoutType: 2,
    data: {
        name: 'about-us',
        layoutType: 2,
        areasList: [
            {
                id: 'about-page-area',
                name: 'Content',
                componentName: 'Comp:AboutPage',
                content: JSON.stringify(aboutContent),
            },
        ],
    },
};

export default aboutMock;
